import Portfolio from "../../../commonComponents/portfolio";
import VideoModal from "../../../commonComponents/modals/VideoModal";

const PortfolioGalleryIconContainer = () => {
  return (
    <>
      <Portfolio sectionClass="portfolio-video" type="gallery" gridSize={3} carShow={9} />
      <VideoModal />
    </>
  );
};

export default PortfolioGalleryIconContainer;
